<template>
    <div class="aside" :class="{'close': !asideCollapseButton}" v-if="userInfo">
        <div class="aside-open__list mobile-view">
            <div class="aside-open__router-link">使用者：{{userName}}</div>
        </div>
        <div class="aside-open__list mobile-view">
            <router-link class="aside-open__router-link" :to="`${root}/account/info`">
                <i class="aside-open__router-link-icon el-icon-user-solid"></i>
                <span class="aside-open__router-link-text">我的帳戶</span>
            </router-link>
        </div>
        <div class="aside-open__list">
            <router-link class="aside-open__router-link" :to="`${root}/service/summary`">
                <i class="aside-open__router-link-icon el-icon-s-marketing"></i>
                <span class="aside-open__router-link-text">摘要總覽</span>
            </router-link>
            <router-link class="aside-open__router-link" :to="`${root}/service/site`">
                <i class="aside-open__router-link-icon el-icon-s-management"></i>
                <span class="aside-open__router-link-text">我的場站</span>
            </router-link>
        </div>
        <el-collapse class="aside-open__collapse" v-model="meauCollapse">
            <el-collapse-item class="aside-open__collapse-item" name="report">
                <span slot="title">服務</span>
                <router-link class="aside-open__router-link" :to="`${root}/service/apiToken`">
                    <i class="aside-open__router-link-icon el-icon-s-check"></i>
                    <span class="aside-open__router-link-text">憑證管理</span>
                </router-link>
                <router-link class="aside-open__router-link" :to="`${root}/report/ntpReport`">
                    <i class="aside-open__router-link-icon el-icon-s-promotion"></i>
                    <span class="aside-open__router-link-text">新北報表</span>
                </router-link>
            </el-collapse-item>
        </el-collapse>
        <div class="aside-open__list mobile-view">
            <button type="button" class="aside-open__router-link" @click="toLogout()">登出</button>
        </div>
    </div>
</template>
<script>
import * as api from "@/script/apiService/api.js"
export default {
    name: "pacaAside",
    data(){
        return{
            userInfo: this.$store.state.userInfo,
            root: process.env.VUE_APP_PACACLOUND_ROOT,
            beforeCloseAsideCollapse: ['service', 'partner', 'report', 'admin'],
        }
    },
    methods: {
        changeLocale(locale){
            this.$message.success({
                duraction: 2500,
                showClose: true,
                message: this.$t("footer.changeLanguage")
            })
            this.$i18n.locale = locale;
        },
        async toLogout(){
            await api.postLogout();
        },
    },
    computed:{
        meauCollapse: {
            set(openingItem){
                this.$store.commit({
                    type: "setMeauCollapse",
                    open: openingItem
                })
            },
            get(){
                return this.$store.state.meauCollapse
            }
        },
        asideCollapseButton(){
            return this.$store.state.asideCollapseButton
        },
        userName(){
            return this.$store.state.userInfo ? this.$store.state.userInfo.nickname : ''
        }
    },
    watch: {
        asideCollapseButton(val){
            if(window.innerWidth > 992){
                if(val == false){
                    this.beforeCloseAsideCollapse = this.meauCollapse;
                    this.$store.commit({
                        type: "setMeauCollapse",
                        open: ['service', 'partner', 'report', 'admin'],
                    })
                }else{
                    this.$store.commit({
                        type: "setMeauCollapse",
                        open: this.beforeCloseAsideCollapse
                    })
                }
            }
        }
    }
}
</script>